;
define("product_list_control_single.tpl", function(){});

